export const checkLogin = async () => {
  const user_token = localStorage.getItem("user_token");

  if (user_token) {
    return await true;
  }
  return await false;
};
